import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueFeather from 'vue-feather'
import VueGtag from 'vue-gtag'

createApp(App).use(store).use(router).use(VueGtag, { config: { id: 'G-M4K7F3SDKB' } }).component(VueFeather.name, VueFeather).mount('#app')
